export const introduce = {
  text: '该指标统计了持有余额  > 10K 的链上地址总量',
  height: 1200,
};
